export interface ICalendarTaskAmount {
    amount: number;
}

export class CalendarTaskAmount implements ICalendarTaskAmount {
    amount: number;

    constructor();
    constructor(obj: ICalendarTaskAmount);
    constructor(obj?: any) {
        this.amount = obj && obj.amount || 0;
    }
}